//changed due to package upgrade
import React, { useEffect, useState,useRef } from 'react';
import AppsContainer from '@projectK/components/AppsContainer';
import { useIntl } from 'react-intl';
import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import AppsHeader from '@projectK/components/AppsHeader';
import AppsContent from '@projectK/components/AppsContent';
import AppsPagination from '@projectK/components/AppsPagination';
import Box from '@mui/material/Box';
import AppSearchBar from '@projectK/components/AppSearchBar';
import {
  AuditLogTable,
  AuditLogFilter,
} from '@projectK/modules/General/AuditLog';
import jwtAxios from '@projectK/services/auth/JWT';
import AppInfoView from '@projectK/components/AppInfoView';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { Fonts } from '@projectK/constants/AppEnums';

const AuditLog = () => {
  const companyTheme = CompanyTheme();
  const { messages } = useIntl();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState('');
  const [perPage, setPerPage] = useState(20);
  const [methodFilter, setMethodFilter] = useState('all');
  const [actionFilter, setActionFilter] = useState('all');
  const [modelFilter, setModelFilter] = useState('all');
  const [dateRange, setDateRange] = useState('');
  const [startDateRange, setStartDateRange] = useState('');
  const [userFilter, setUserFilter] = useState('');
  const [createdDateSorting, setCreatedDateSorting] = useState(null);
  const [nameSorting, setNameSorting] = useState(null);
  const [contentSorting, setContentSorting] = useState(null);
  const [actionTypeSorting, setActionTypeSorting] = useState(null);
  const [userRoleSorting, setUserRoleSorting] = useState(null);
  const [createdUserNameSorting, setCreatedUserNameSorting] = useState(null);
  const [actualUserRole, setActualUserRole] = useState(null);
  const [models, setModels] = useState([]);
  const abortControllerRef = useRef(null);
  const handleChangePerPage = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(0);
  };
  const onPageChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    fetchModulesData();
  }, []);
  const fetchModulesData = async () => {
    setLoading(true);
    try {
      const response = await jwtAxios.get(`/audit-logs/routes/models`, {
        params: {
          perPage: 'all',
        },
      });
      const { data } = response;
      setModels(data);
      setLoading(false);
    } catch (error) {
      setModels([]);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
   return () => {
      if (abortControllerRef.current) {
          abortControllerRef.current.abort();
       }
    };
  }, [
    search,
    page,
    perPage,
    methodFilter,
    actionFilter,
    modelFilter,
    dateRange,
    startDateRange,
    userFilter,
    nameSorting,
    contentSorting,
    actualUserRole,
    createdUserNameSorting,
    actionTypeSorting,
    userRoleSorting,
    createdDateSorting,
  ]);

  const fetchData = async () => {
    try {
      setLoading(true);
        abortControllerRef.current = new AbortController();
        const { signal } = abortControllerRef.current;
        const response = await jwtAxios.get(`/audit-logs`, {
        params: {
          search,
          page,
          perPage,
          filters: {
            method: methodFilter !== 'all' ? methodFilter : null,
            action: actionFilter !== 'all' ? actionFilter : null,
            model: modelFilter !== 'all' ? modelFilter : null,
            dateRange: dateRange || undefined,
            startDateRange: startDateRange || undefined,
            user_id: userFilter || undefined,
          },
          sortings: {
            user_name: nameSorting,
            contents: contentSorting,
            actual_userRole: actualUserRole,
            created_userName: createdUserNameSorting,
            action_type: actionTypeSorting,
            user_role: userRoleSorting,
            created_at: createdDateSorting,
          },
        },
        signal,
      });
      const { data } = response;
      setList(data?.list || []);
      setTotal(data.total);
      data.list.length === 0 && page > 0 && setPage(page - 1);
      setLoading(false);
    } catch (error) {
      if (error.message !== 'canceled') {
         console.error('An error occurred:', error);
         setLoading(false);
       } 
    }  
  };

  const onSearchOrder = (value) => {
    setSearch(value);
    setPage(0);
  };

  return (
    <>
      <AuditLogFilter
        methodFilter={methodFilter}
        setMethodFilter={setMethodFilter}
        actionFilter={actionFilter}
        setActionFilter={setActionFilter}
        setModelFilter={setModelFilter}
        modelFilter={modelFilter}
        setDateRange={setDateRange}
        dateRange={dateRange}
        setStartDateRange={setStartDateRange}
        startDateRange={startDateRange}
        setUserFilter={setUserFilter}
        setPage={setPage}
        models={models}
      />
      <br></br>
      <Typography
        variant='h4'
        sx={{
          color: companyTheme ? companyTheme.primary.main : 'text.primary',
          fontWeight: Fonts.SEMI_BOLD,
        }}
      >
        Audit Log
      </Typography>
      <div className='event-search ps-h'>
        <AppsContainer fullView>
          <AppsHeader>
            <Box
              display='flex'
              flexDirection='row'
              alignItems='center'
              width={1}
              justifyContent='space-between'
            >
              <AppSearchBar
                iconPosition='right'
                overlap={false}
                onChange={(event) => onSearchOrder(event.target.value)}
                placeholder={messages['common.searchHere']}
              />

              <Box display='flex' flexDirection='row' alignItems='center'>
              {!isSmDown && (
                <>               <FormControl
                    variant='standard'
                    sx={{
                      borderRadius: 50,
                    }}
                    size='small'
                  >
                    <Select
                      value={perPage}
                      onChange={handleChangePerPage}
                      sx={{ marginLeft: '10px' }}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={30}>30</MenuItem>
                      <MenuItem value={40}>40</MenuItem>
                      <MenuItem value={60}>60</MenuItem>
                      <MenuItem value={80}>80</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </FormControl>
                  <AppsPagination
                    rowsPerPage={perPage}
                    count={total}
                    page={page}
                    onPageChange={onPageChange}
                  />
                </>
              )}
              </Box>
            </Box>
          </AppsHeader>

          <AppsContent
            className='evnt-s-table ps-events'
            sx={{
              paddingTop: 2.5,

              paddingBottom: 2.5,
            }}
          >
            <AuditLogTable
              emailtemplateData={list}
              loading={loading}
              fetchData={fetchData}
              createdDateSorting={createdDateSorting}
              setCreatedDateSorting={setCreatedDateSorting}
              actionTypeSorting={actionTypeSorting}
              setActionTypeSorting={setActionTypeSorting}
              nameSorting={nameSorting}
              setNameSorting={setNameSorting}
              userRoleSorting={userRoleSorting}
              setUserRoleSorting={setUserRoleSorting}
              createdUserNameSorting={createdUserNameSorting}
              setCreatedUserNameSorting={setCreatedUserNameSorting}
              contentSorting={contentSorting}
              setContentSorting={setContentSorting}
              actualUserRole={actualUserRole}
              setActualUserRole={setActualUserRole}
              models={models}
            />
          </AppsContent>

          {!isSmUp && (
            <>           <FormControl
              variant='standard'
              sx={{
                borderRadius: 50,
              }}
              size='small'
              className='cols-count colc'
            >
              <Select
                value={perPage}
                onChange={handleChangePerPage}
                sx={{ marginLeft: '10px', height: '34px' }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
                <MenuItem value={40}>40</MenuItem>
                <MenuItem value={60}>60</MenuItem>
                <MenuItem value={80}>80</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
            <AppsPagination
              className='cols-pagination'
              rowsPerPage={perPage}
              count={total}
              page={page}
              onPageChange={onPageChange}
            />
          </>
          )}

          <AppInfoView />
        </AppsContainer>
      </div>
    </>
  );
};

export default AuditLog;
